import { h } from 'preact';
import UIElement from '../internal/UIElement/UIElement';
import MultibancoVoucherResult from './components/MultibancoVoucherResult';
import RedirectButton from '../internal/RedirectButton';
import { TxVariants } from '../tx-variants';
import { VoucherConfiguration } from '../internal/Voucher/types';

export class MultibancoElement extends UIElement<VoucherConfiguration> {
    public static readonly type = TxVariants.multibanco;

    get isValid() {
        return true;
    }

    formatProps(props) {
        return {
            ...props,
            name: props.name || 'Multibanco'
        };
    }

    /**
     * Formats the component data output
     */
    formatData() {
        return {
            paymentMethod: {
                type: this.props.type || MultibancoElement.type
            }
        };
    }

    protected override componentToRender(): h.JSX.Element {
        if (this.props.reference) {
            return <MultibancoVoucherResult {...this.props} onActionHandled={this.onActionHandled} />;
        }

        return (
            <RedirectButton
                name={this.displayName}
                payButton={this.payButton}
                onSubmit={this.submit}
                setComponentRef={this.setComponentRef}
            />
            );
    }
}

export default MultibancoElement;
